import { render, staticRenderFns } from "./ManagerWizard.vue?vue&type=template&id=c9585f32"
import script from "./ManagerWizard.vue?vue&type=script&lang=js"
export * from "./ManagerWizard.vue?vue&type=script&lang=js"
import style0 from "./ManagerWizard.vue?vue&type=style&index=0&id=c9585f32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports